import React from "react";
import { WHY_POINTS, BRAND } from "@/constants/brand";

export const WhyInfolocus = () => {
  return (
    <section id="why" data-testid="why-section" className="py-24 md:py-32 bg-white border-y border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <p className="uppercase text-xs tracking-[0.22em] font-bold text-[#0055FF]">
              Why Infolocus
            </p>
            <h2 className="font-display mt-4 text-4xl md:text-5xl tracking-tight font-bold text-[#0B1120] leading-tight">
              Built for how Indian SMEs actually operate.
            </h2>
            <p className="mt-6 text-base md:text-lg text-[#475569] leading-relaxed">
              Most digital transformation falls apart at execution. We sit on your side of
              the table — sizing solutions to your reality, owning delivery, and tying every
              project to a business metric you can defend in a board meeting.
            </p>

            <div className="mt-10 border border-[#E2E8F0] rounded-sm overflow-hidden">
              <img
                src={BRAND.meetingImageUrl}
                alt="Indian business team in a strategy meeting"
                className="w-full h-72 md:h-80 object-cover"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <div
              data-testid="why-grid"
              className="grid grid-cols-1 md:grid-cols-2 border border-[#E2E8F0] rounded-sm overflow-hidden"
            >
              {WHY_POINTS.map((p, i) => (
                <div
                  key={p.title}
                  data-testid={`why-point-${i}`}
                  className={`p-8 md:p-10 bg-white hover:bg-[#FAFAFA] transition-colors ${
                    i % 2 === 0 ? "md:border-r" : ""
                  } border-[#E2E8F0] ${
                    i < WHY_POINTS.length - 2 ? "border-b" : "md:border-b-0 border-b"
                  } ${i === WHY_POINTS.length - 1 ? "border-b-0" : ""}`}
                >
                  <div className="flex items-baseline gap-3">
                    <span className="font-display text-xs font-bold text-[#94A3B8]">
                      0{i + 1}
                    </span>
                    <h3 className="font-display text-xl md:text-2xl font-bold text-[#0B1120] leading-snug">
                      {p.title}
                    </h3>
                  </div>
                  <p className="mt-3 text-[15px] text-[#475569] leading-relaxed">
                    {p.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
